export default __webpack_public_path__ + "images/CM.a6df200.png";